const ordering = {
  eyebrow: 'Cómo trabajamos',
  title: 'De la consulta a la entrega',
  lead: 'Cinco pasos, dos de ellos suyos. Enviamos la cotización en un día hábil y nada queda comprometido hasta que usted confirme.',
  photoCaption: 'Ramas de canela clasificándose antes del empaque.',
  requestQuote: 'Solicitar cotización',
  whatsappLink: 'o escríbanos por WhatsApp',

  processTitle: 'El proceso',
  yourStep: 'Su paso',
  ourStep: 'Nuestro paso',
  steps: [
    { who: 'you', title: 'Envíe sus requisitos', time: 'En cualquier momento', detail: 'Grado (o el uso que le dará), cantidad, empaque y destino. ¿No sabe qué grado? Describa su producto.' },
    { who: 'us', title: 'Le enviamos la cotización', time: 'En 1 día hábil', detail: 'Con precio según su cantidad y condiciones de envío. Si quiere revisar la calidad, podemos enviar muestras primero.' },
    { who: 'you', title: 'Confirme y pague', time: 'Factura proforma en 1 día hábil', detail: 'Acepte la cotización, reciba la factura proforma y realice el pago. Nada queda comprometido hasta que confirme.' },
    { who: 'us', title: 'Clasificamos y empacamos', time: 'Se confirma en su cotización', detail: 'Clasificada, revisada y empacada según sus especificaciones: cajas a granel, empaques para menudeo o marca propia.' },
    { who: 'us', title: 'Lo enviamos', time: 'Marítimo o aéreo', detail: 'Despachado en las condiciones que eligió, con avisos hasta que llegue.' },
  ],

  termsTitle: 'Condiciones de pedido',
  termsIntro: 'Aplican a todos los pedidos. Lo específico de su pedido se indica en la cotización.',
  terms: [
    { label: 'Pedido mínimo', value: 'Varía según el producto. Volúmenes personalizados a solicitud; el precio unitario depende de la cantidad.' },
    { label: 'Pago', value: 'Antes de iniciar la producción. Transferencia bancaria (TT), carta de crédito (LC), tarjeta o PayPal.' },
    { label: 'Condiciones de envío', value: 'EXW, FOB, CFR, CIF o DAP, por vía marítima o aérea.' },
    { label: 'Muestras', value: 'Disponibles a solicitud. El envío de muestras se cobra al costo.' },
    { label: 'Tiempo de entrega', value: 'Depende del producto y del tamaño del pedido. Se confirma en su cotización.' },
    { label: 'Marca propia', value: 'Disponible. Cuéntenos sobre su marca y sus empaques.' },
    { label: 'Certificaciones', value: 'Clasificación SLS 81, Ceylon Cinnamon PGI, logo Pure Ceylon Cinnamon, GMP, ISO 22000, BRCGS y Halal. Exportador registrado ante el EDB.' },
    { label: 'Documentos de embarque', value: 'Certificado fitosanitario, certificado de origen, certificado de análisis y certificado de fumigación.' },
  ],

  ctaTitle: '¿Listo para cotizar?',
  ctaText: 'Envíenos el grado, la cantidad y el destino. Respondemos en un día hábil.',
};

export default ordering;
